import { useIntl } from 'react-intl';

export const useFormatMessage = () => {
    const intl = useIntl();
    return (descriptor, values) => intl.formatMessage(descriptor, values);
};

export const useFormatNumber = () => {
    const intl = useIntl();
    return (value, opts) => intl.formatNumber(value, opts);
};
